const calendarAppliesToOffice = (
  calendar: { officeIds?: Array<string> | null },
  officeId: string,
): boolean => {
  if (!calendar.officeIds?.length) return true;
  return calendar.officeIds.includes(officeId);
};

export default calendarAppliesToOffice;
